import p1 from './gallery/pizza.jpg'
import p2 from './gallery/pizza1.webp'
import p3 from './gallery/pizza2.jpg'
import p4 from './gallery/pizza4.jfif'
import s1 from './gallery/salad.jpg'
import s2 from  './gallery/salad1.jpg'
import s3 from './gallery/salad2.jpg'
import s4 from './gallery/salad3.webp'
import n1 from './gallery/noodle.jfif'
import n2 from './gallery/noodle1.jpg'
import n3 from './gallery/noodle2.jpg'
import n4 from './gallery/noodle4.jpg'

export const images = {
    p1,
    p2,
    p3,
    p4,
    s1,
    s2,
    s3,
    s4,
    n1,
    n2,
    n3,
    n4
}